module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_5010.65965da9.png";